import React from "react";
import s from "./Team.module.scss";
import TeamMember from "../TeamMember/TeamMember";
import PageTitle from "../PageTitle/PageTitle";

const members = [
  {
    name: "Mr. IGBAL BABAYEV",
    img: "/images/babayev.jpg",
    country: "",
    cv: "/files/CV-Igbal Babayev.pdf",
    position: "Head of the Advisory Committee",
    flag: "/logo.png",
    description:
      "Deputy Chairman of the SCC of Azerbaijan (2018–2022), 18 years of professional experience in customs. General Major.",
  },
  {
    name: "Mr. UMUT SHEDELE",
    img: "/images/Umut.jpg",
    country: "Turkey",
    cv: "/files/CV-Umut.pdf",
    position: "",
    flag: "/images/turkey.png",
    description:
      "Customs Expert, General Directorate of Customs, Republic of Turkey (2006-2016)  Chairman of The Board SDL Authorized Customs Brokerage (2017 - present) 19 years of professional experience in the customs field. ",
  },
  {
    name: "Mr. VAKHTANG LASHKARADZE",
    img: "/images/Lashkaradze.jpg",
    country: "Georgia",
    cv: "/files/CV-Vakhtang Lashkaradze.pdf",
    position: "",
    flag: "/images/georgia.png",
    description:
      "Deputy Director General of the Revenue Service of Georgia / Responsible for coordinating the Customs Department (2014–2019). Director General of the Revenue Service of Georgia (2019–2020).   27 years of professional experience in customs.  Colonel.",
  },
  {
    name: "Mr. FIKRET ALESGERLI",
    img: "/images/Fikret-Elesgerli1.jpg",
    country: "Azerbaijan",
    cv: "/files/CV - Fikret Elesgerli.pdf",
    position: "",
    flag: "/images/azerbaijan.png",
    description:
      "Deputy head of the General Department of Intelligence and Investigation  of the SCC of Azerbaijan (2018–2022), 23 years of professional experience in customs. Colonel.",
  },
  {
    name: "Mr. VADIM MUNTEAN",
    img: "/images/muntean.jfif",
    country: "Moldova",
    cv: "/files/CV-Vadim Muntean.pdf",
    position: "",
    flag: "/images/moldova.png",
    description:
      "Deputy Head of the Revenues and Customs Control Department of Moldova (2015–2016). Administrator of the Customs Services Office, established by the Customs Service of Moldova (2016–2022). 28 years of professional experience in the customs field.",
  },

  {
    name: "Mr. GOSMAN AMRIN",
    img: "/images/Amrin.jpg",
    country: "Kazakhstan",
    cv: "/files/Amrin Gosman Karimovich.pdf",
    position: "",
    flag: "/images/kazakhstan.png",
    description:
      "Chairman of the Customs Control Committee of the Ministry of Finance of the Republic of Kazakhstan (2013–2014) Deputy Chairman of the State Revenue Committee of the Ministry of Finance of the Republic of Kazakhstan (2014–2019) Colonel.",
  },
  {
    name: "Mr. GAYRAT NURJAVOV",
    img: "/images/Nurjanov.jpeg",
    country: "Uzbekistan",
    cv: "/files/CV_Gayrat_Nurjavov_English.pdf",
    description:
      "Over 25 years of experience in the customs authorities of the Republic of Uzbekistan. Colonel of the Customs Service (retired 2024). Former e-commerce executive (2024–2025). Founder of a customs brokerage company and co-founder of a customs terminal company.",
    flag: "/images/uzbekistan.png",
  },
  {
    name: "Mr. KADYRZHAN SEMETEEV",
    img: "/images/Семеетев Кадыржан.jpg",
    country: "Kyrgyzstan",
    cv: "/files/Резюме Семетеева.pdf",
    description:
      "Chairman of the Customs Control Committee of the Ministry of Finance of the Kyrgyz Republic (2020). Head of the Post-Clearance Control Department of the State Customs Service (2018–2020). Colonel.",
    flag: "/images/kyrgyzstan.png",
  },
  {
    name: "Mr. ANATOLY MAKARENKO",
    img: "/images/Anatoliy Makarenko 1 (1).jpg",
    country: "Ukraine",
    cv: "/files/Anatoly Viktorovych Makarenko.pdf",
    position: "",
    flag: "/images/ukraine.png",
    description:
      "Chairman of the State Customs Service of Ukraine (2009–2010). Deputy Chairman of the State Fiscal Service of Ukraine (2014–2015). 16 years of professional experience in the customs field.  General lieutenant",
  },
  {
    name: "Mr. PAVLO PASHKO",
    img: "/images/pashko.jpg",
    country: "Ukraine",
    cv: "/files/CV_Pavlo Pashko.pdf",
    position: "",
    flag: "/images/ukraine.png",
    description:
      "Deputy Head of the State Customs Service of Ukraine (2001–2010). Director of the Department of Customs Affairs Development, State Fiscal Service (2014–2016). Rector of the University of the State Fiscal Service (2016–2021). Professor, NAU (since 2022). Over 20 years of experience in customs.",
  },
  {
    name: "",
    img: "/images/no-photo.png",
    country: "Tajikistan",
    cv: "",
    position: "",
    flag: "/images/tajikistan.png",
  },
  {
    name: "",
    img: "/images/no-photo.png",
    country: "Turkmenistan",
    cv: "",
    position: "",
    flag: "/images/turkmenistan.png",
  },
];

const Team = () => {
  return (
    <div className={s.team}>
      <PageTitle className={s.h2} eyebrow="The Board" title="Members of the Board" />
      <div className={s.members}>
        {members
          .sort((a, b) =>
            a.country.localeCompare(b.country, "en", { sensitivity: "base" }),
          )
          .map((member) => (
            <TeamMember member={member} />
          ))}
      </div>
    </div>
  );
};

export default Team;
